///-- THIS FILE IS GENERATED --///
export enum ListStylePosition {

    LIST_INSIDE = "pinata-list-inside",

    LIST_OUTSIDE = "pinata-list-outside",

}